/* Réplica de `.content-header` de la app web. */
.cabecera {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.6rem;
  padding: 0.65rem 0.85rem;
  background: var(--card);
  border: var(--borde-tarjeta);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-flotante);
}

.titulo {
  flex: 1;
  min-width: 0;
}

.titulo h2 {
  font-size: 1.4rem;
  font-weight: var(--peso-titulo);
  color: var(--text-1);
  margin: 0;
}

.descripcion {
  margin-top: 0.2rem;
  color: var(--text-2);
  font-size: 0.85rem;
}

.acciones {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}

/*
 * En móvil la cabecera es UNA sola línea: título, las acciones de la pantalla
 * reducidas a su icono, y el menú de preferencias pegado al borde derecho.
 *
 * Apilada ocupaba un cuarto de la pantalla antes de enseñar un solo dato. El
 * título dice dónde estás y con eso basta; la descripción explica de qué va la
 * pantalla, se lee una vez y aquí sale cara.
 */
@media (max-width: 767px) {
  .cabecera {
    flex-wrap: nowrap;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 0.6rem;
    margin-bottom: 0.6rem;
  }

  .titulo h2 {
    font-size: 1.15rem;
    /* Un título largo se recorta en vez de empujar los botones fuera. */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .descripcion {
    display: none;
  }

  .acciones {
    flex-wrap: nowrap;
    gap: 0.35rem;
  }
}
